import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import MobileHeader from "./components/MobileHeader/MobileHeader";
import SideBtn from "./components/SideBtn/SideBtn";
import Configuration from "./Configuration/Configuration";

function App() {
  return (
    <>
      <Header/>
      <MobileHeader/>
      <SideBtn/>
     <Configuration/>
      <Footer/>
    </>
  );
}

export default App;
